
import React from 'react';
import axios from 'axios';
import $ from 'jquery';
import { getSessionID, getSessionName, getCompanyID } from '../../../../Utils/Common';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import paginationFactory from 'react-bootstrap-table2-paginator';
import AddClassificationChoice from './addClassificationChoice';


class ClassificationChoice extends React.Component {
  constructor () {
      super();

      this.state = {
        tableData:[]
      };
  }

  componentDidMount () {
    let self = this;

    const session_Name = getSessionName();
    if (!session_Name) {
      return;
    }
  
    const session_ID = getSessionID();
    if (!session_ID) {
      return;
    }
  
    const company_id = getCompanyID();
    if (!company_id) {
      return;
    }   

    axios.get('http://payroll.nikkolim.com/get_class_choice/class_choice_company/'+company_id, {
    headers: {
      'Content-Type': 'application/json',
      "Authentication": session_Name+"="+session_ID,
    }
  })
  .then((response) => {
    const data = [];
    $.each( response.data, function( i, val ) {   

      $.each(val, function( i, val2 ){
        data.push(val2.attributes);
        self.setState({ tableData: data });
        //console.log(JSON.stringify(val2.attributes));
      })
      
    });
     //console.log(JSON.stringify(response.data));
  }, (error) => {
    console.log(error);
  });
  
  }

  render () {
      const { tableData } = this.state;
      const textfilter = { type: 'TextFilter', delay: 1000};

      let datalist = [{
        dataField: 'field_empclasschoice_name',
        text: 'Choice'
      },{
        dataField: 'field_empclasschoice_company_label',
        text: 'Company',
      },{
        dataField: 'field_empclasschoice_type_label',
        text: 'Label',
      },{
        dataField: 'field_empclasschoice_default',
        text: 'Default',
      },{
        dataField: 'field_empclasschoice_active',
        text: 'Active',
      },{
        dataField: 'entity_id',
        text: 'ID',
      }];

      return (
      <div>
        <h1 className="h3 mb-0 text-gray-800">Classification Choice</h1>
        <div className="add-button"><AddClassificationChoice></AddClassificationChoice></div>
        <BootstrapTable responsive  wrapperClasses='table-responsive' bootstrap4 version='4' keyField='field_employee_id' columns={ datalist } data={ tableData } pagination={ paginationFactory() } search>
          <TableHeaderColumn dataSort dataField='field_empclasschoice_name' filter={textfilter}>Choice</TableHeaderColumn>
          <TableHeaderColumn dataSort  dataField='field_empclasschoice_company_label' filter={textfilter}>Company</TableHeaderColumn>
          <TableHeaderColumn dataSort  dataField='field_empclasschoice_type_label' filter={textfilter}>Label</TableHeaderColumn>
          <TableHeaderColumn dataSort  dataField='field_empclasschoice_default' filter={textfilter}>Default</TableHeaderColumn>
          <TableHeaderColumn dataSort  dataField='field_empclasschoice_active' filter={textfilter}>Active</TableHeaderColumn>
        </BootstrapTable>
      </div>  
      );
  }
};



export default ClassificationChoice;

